import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';

export enum MediaSource {
  Camera = 'camera',
  Gallery = 'gallery'
}

export interface MediaSourceConfig {
  header: string;
  preventGallery?: boolean;
  cameraText?: string;
  galleryText?: string;
  cameraIcon?: string;
  galleryIcon?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MediaSourceSelectionService {
  constructor(private actionSheetCtrl: ActionSheetController) {}

  async promptForSelection(config: MediaSourceConfig): Promise<MediaSource | undefined> {
    if (config.preventGallery) {
      return MediaSource.Camera;
    }

    const sheet = await this.actionSheetCtrl.create({
      header: config.header,
      buttons: [
        {
          text: config.cameraText || 'Use Camera',
          icon: config.cameraIcon || 'camera-outline',
          handler: () => sheet.dismiss(MediaSource.Camera)
        },
        {
          text: config.galleryText || 'Select from Gallery',
          icon: config.galleryIcon || 'image-outline',
          handler: () => sheet.dismiss(MediaSource.Gallery)
        }
      ]
    });

    await sheet.present();
    const { data } = await sheet.onDidDismiss();
    return data;
  }
}
